import { render as renderProductInformationHeader } from './components/product-information-header'
import template from '../common/template'

const productInformationHeader = (basicPlan, selectedPlanCode, redLine) =>
  renderProductInformationHeader(basicPlan, selectedPlanCode, redLine)

const protectionTemplate = async (props) => {
  const { basicPlan, selectedPlanCode, redLine } = props
  const header = productInformationHeader(basicPlan, selectedPlanCode, redLine)
  return template(props, header)
}

export default protectionTemplate
